import { render, staticRenderFns } from "./IpoActiveOrder.vue?vue&type=template&id=33c58d8e"
import script from "./IpoActiveOrder.vue?vue&type=script&lang=js"
export * from "./IpoActiveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports